import React, { useEffect } from "react";
import {
  getPrincipioActivoCategoria,
  resetPrincipiosActivosCategoriaFlag,
} from "../../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useParams } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Alert,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Editar from "./Editar";
import { DatosSesion } from "../../../Components/Common/DatosSesion";

const PrincipioActivoCategoriaEditar = () => {
  // Obtiene el ID desde la URL
  const { id } = useParams();
  const dispatch = useDispatch();
  const perfil = DatosSesion("perfil");

  useEffect(() => {
    dispatch(getPrincipioActivoCategoria(id));
  }, [dispatch, id]);

  const selectLayoutState = (state) => state;
  const principiosActivosPageData = createSelector(
    selectLayoutState,
    (state) => ({
      principioActivoCategoria:
        state.PrincipiosActivosCategorias.principioActivoCategoria,
      error: state.PrincipiosActivosCategorias.error,
      loading: state.PrincipiosActivosCategorias.loading,
      errorMsg: state.PrincipiosActivosCategorias.errorMsg,
      colorMsg: state.PrincipiosActivosCategorias.colorMsg,
      exito: state.PrincipiosActivosCategorias.exito,
    })
  );

  // Inside your component
  const {
    principioActivoCategoria,
    error,
    loading,
    errorMsg,
    colorMsg,
    exito,
  } = useSelector(principiosActivosPageData);

  useEffect(() => {
    if (errorMsg) {
      setTimeout(() => {
        dispatch(resetPrincipiosActivosCategoriaFlag());
      }, 3000);
    }
  }, [dispatch, errorMsg]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {perfil === "Administrador" ||
          perfil === "Farmacia" ||
          perfil === "MyHealth" ? (
            <>
              <BreadCrumb
                title="Editar Principio Activo Categoria"
                pageTitle="Listar Principios Activos Categorias"
                url="/principiosactivoscategorias"
              />
              <Row>
                <Col lg={12}>
                  <Card>
                    <CardHeader className="border-0">
                      {errorMsg && errorMsg ? (
                        <Alert color={colorMsg}> {error} </Alert>
                      ) : null}
                    </CardHeader>
                    <CardBody>
                      {exito && (
                        <Editar
                          principioActivoCategoria={principioActivoCategoria}
                        />
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          ) : (
            <Alert color="danger">
              No tienes permisos para ver esta página.
            </Alert>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PrincipioActivoCategoriaEditar;
